/* Submits the existing support form to its configured Formspree endpoint. */
if (!customElements.get('sam-contact-form')) {
  customElements.define('sam-contact-form', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.button = this.querySelector('[data-form-submit]');
      this.success = this.querySelector('[data-form-success]');
      this.error = this.querySelector('[data-form-error]');
      this.abort = new AbortController();
      this.form?.addEventListener('submit', event => this.onSubmit(event), { signal: this.abort.signal });
    }

    async onSubmit(event) {
      event.preventDefault();
      if (this.sending || this.sent || !this.form.reportValidity()) return;
      this.sending = true;
      this.button.disabled = true;
      this.button.classList.add('loading');
      this.form.setAttribute('aria-busy', 'true');
      if (this.error) this.error.hidden = true;
      try {
        const response = await fetch(this.form.action, {
          method: 'POST',
          body: new FormData(this.form),
          headers: { Accept: 'application/json' },
          signal: this.abort.signal,
        });
        if (!response.ok) throw new Error(`Form error ${response.status}`);
        this.sent = true;
        this.showSuccess();
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.button.disabled = false;
        if (this.error) this.error.hidden = false;
        const label = this.button.querySelector('[data-form-label]');
        if (label) label.textContent = this.getAttribute('error-label') || 'TRY AGAIN';
      } finally {
        this.sending = false;
        this.button.classList.remove('loading');
        this.form.removeAttribute('aria-busy');
      }
    }

    showSuccess() {
      this.button.classList.add('success');
      this.button.textContent = this.getAttribute('sent-label') || 'SENT';
      this.dispatchEvent(new CustomEvent('sam:form-submitted', { bubbles: true }));
      if (!this.success) return;
      this.form.style.display = 'none';
      this.success.classList.add('visible');
      this.success.setAttribute('tabindex', '-1');
      this.success.focus();
    }

    disconnectedCallback() {
      this.abort?.abort();
    }
  });
}
